import React from 'react'
import Hero from '../Sections/Project/Hero'
import ProjectsSection from '../Sections/Project/Projects'
import Restoration from '../Sections/Project/Resotraion'
function Project() {
  return (
    <>
      {/* <Hero/> */}
      <Restoration/>
      <ProjectsSection/>
    </>
  )
}

export default Project
